import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        close: '&',
        companyTerms: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.close()"></button>
            <h2>{{ 'general.Terms and conditions' | translate }}</h2>
        </div>
        <div class="modal-body">
            <div class="terms01 large">
                <h3 ng-if="vm.companyTerms">{{ 'user.Terms and Conditions' | translate }}</h3>
                <p ng-bind-html="vm.companyTerms"></p>
                <h3>{{ 'user.Coursy site privacy policy' | translate }}</h3>
                <div ng-bind-html="vm.coursyTerms"></div>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary"><button class="btn main" type="button" ng-click="vm.close()">{{ 'general.Ok' | translate }}</button></li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate) {
        this.coursyTerms = $translate.instant('user.Coursy terms and conditions');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/account/termsAndConditions/index.js